import React from 'react';
import { motion } from 'framer-motion';
const StatCard = ({
  value,
  label,
  delay
}: {
  value: string;
  label: string;
  delay: number;
}) => <motion.div initial={{
  opacity: 0,
  y: 20
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true
}} transition={{
  delay
}} className="text-center p-8 glass-card rounded-3xl" data-id="element-169">
    <p className="text-5xl md:text-6xl font-serif font-bold text-brand-accent mb-4" data-id="element-170">
      {value}
    </p>
    <p className="text-sm text-slate-400 uppercase tracking-widest font-bold" data-id="element-171">
      {label}
    </p>
  </motion.div>;
export function Results() {
  return <section className="py-24 bg-brand-dark" data-id="element-172">
      <div className="container mx-auto px-6" data-id="element-173">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6" data-id="element-174">
          <StatCard value="40-60%" label="Appointment Growth" delay={0.1} data-id="element-175" />
          <StatCard value="3-5x" label="Lead Increase" delay={0.2} data-id="element-176" />
          <StatCard value="50%" label="Faster Hiring" delay={0.3} data-id="element-177" />
          <StatCard value="24/7" label="Support Scaling" delay={0.4} data-id="element-178" />
          <StatCard value="200%" label="Sales Growth" delay={0.5} data-id="element-179" />
        </div>
      </div>
    </section>;
}